<h2 mat-dialog-title> Subir ficheros </h2>
<mat-dialog-content>

  <ngx-dropzone (change)="onSelect($event)">
    <ngx-dropzone-label>¡Arrastra ficheros o haz click!</ngx-dropzone-label>
    @for (f of files; track f) {
      <ngx-dropzone-preview [removable]="true" (removed)="onRemove(f)" class='preview'>
        <ngx-dropzone-label class='blockData'>{{ f.name }}</ngx-dropzone-label>
        @if (f.progress > 1) {
          <ngx-dropzone-label class='blockData'>
            {{ f.progress }}%
            <mat-progress-bar [mode]="determinate" [value]="f.progress" class='loadingBar'>
            </mat-progress-bar>
          </ngx-dropzone-label>
        }
      </ngx-dropzone-preview>
    }
  </ngx-dropzone>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-button (click)="save()">Subir</button>
</mat-dialog-actions>
